import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Access the state from the location object and provide fallbacks
  const message = location.state?.message || t('The page you are looking for does not exist.');
  const redirectUrl = location.state?.redirectUrl || '/';
  const pageTitle= location.state?.pageTitle || t('Page Not Found');

  return (
    <div className="container mt-5 text-center">
      <h1>{pageTitle}</h1>
      <p>{message}</p>
      <Link to={redirectUrl} className="btn btn-primary">{t('Go to Home')}</Link>
    </div>
  );
};

export default NotFound;
